export const TICK_RATE = 30;
export const DT = 1 / TICK_RATE;

/** Capsule every unit collides with, centered on its position. Feet are at `y - HALF_HEIGHT`. */
export const UNIT_RADIUS = 0.5;
export const UNIT_HEIGHT = 1.5;
export const UNIT_HALF_HEIGHT = UNIT_HEIGHT / 2;

export const RUN_SPEED = 7;
/** WoW backpedals at 4.5 yd/s against a 7 yd/s run. */
export const BACKPEDAL_FACTOR = 4.5 / 7;
export const JUMP_VELOCITY = 7.5;
/** Fraction of run speed a unit airborne without momentum can drift toward its input. */
export const AIR_CONTROL = 2.5 / 7;
export const KEYBOARD_TURN_RATE = Math.PI;

/** World units per Kenney tile. */
export const TILE_SIZE = 3;
export const CHARACTER_SCALE = 1.8;

export const MELEE_RANGE = 2.5;
export const GCD = 1.5;
/** Pressing an ability this close to the end of the GCD or a cast queues it. */
export const SPELL_QUEUE_WINDOW = 0.4;
